
// # Bootstrap
require('./bootstrap');

// # Plugins
require('./plugins/scrollmagic/scrollmagic');
require('./plugins/imagesloaded/imagesloaded');
require('./plugins/match-height/match-height');
require('./plugins/jump/jump');
require('./plugins/slick/slick');
require('./plugins/lightbox/lightbox');

// # Utilities
require('./utilities/removeParamURL');

// # Vue
require('./vue');

// # Plugins (that should come after Vue)
require('./plugins/goodshare/goodshare');
require('./plugins/jquery-lazy/jquery-lazy');

// # Components
require('./components/nav');
require('./components/animate');
require('./components/filter');
require('./components/product-nav');
require('./components/features');
require('./components/gallery-video');
require('./components/map');
require('./components/lazy-background');
require('./components/lazy-iframe');

$('.gallery__slidetabitem').on('shown.bs.collapse', function (e) {

  $(e.currentTarget).find('.tabgallery').slick('refresh');

}).on('hide.bs.collapse', function (e) {

  //

}).on('show.bs.collapse', function (e) {

  $(e.currentTarget).find('.st__left ul li').removeClass('active');
  $( $(e.currentTarget).find('.st__left ul li')[$(e.target).index()] ).addClass('active');

})
